
import * as homeApi from './home'
import * as searchApi from './search'
import * as commonApi from './common'
import * as favApi from './favorites'
import * as commentsApi from './comments'



export const HOME = homeApi
export const SEARCH = searchApi
export const COMMON = commonApi
export const FAV = favApi
export const COMMENTS = commentsApi


// WEBPACK FOOTER //
// ./src/api/index.js